import { create } from "zustand";
import api from "../api/api"; // ✅ Use centralized API

const useAuthStore = create((set) => ({
    user: null,
    error: null,
    loading: false,

    login: async (email, password) => {
        set({ loading: true, error: null });
        try {
            const response = await api.post("/auth/login", { email, password });
            set({ user: response.data, loading: false });
            localStorage.setItem("user", JSON.stringify(response.data)); // ✅ Save user data
        } catch (error) {
            set({ error: "Invalid email or password", loading: false });
        }
    },

    logout: () => {
        set({ user: null });
        localStorage.removeItem("user");
    }
}));

export default useAuthStore;
